<script>
import {ref, watch} from "vue";
import axios from "axios";
import useSharedMethod from "@/use/SharedMethod";

export default {
    props: {
        paySlipId: Number,
    },
    setup(props) {
        const {priceFormat} = useSharedMethod();
        const loading = ref(false);
        const correction = ref({
            correctionPaySlips: [],
            correctionPaySections: [],
            correctionValues: [],
        });
        
        function findBySlipId() {
            loading.value = true;
            axios.get(`/corrections/paySlip/${props.paySlipId}`).then(response => {
                correction.value = response.data;
            }).finally(() => {
                loading.value = false;
            });
        }
        
        watch(() => props.paySlipId, () => {
            if (props.paySlipId)
                findBySlipId();
        }, {immediate: true});
        
        return {
            loading,
            correction,
            priceFormat
        }
        
    }
}
</script>

<template>
    <v-container fluid>
        <w-fieldset :title="$t('pay_slip.pay_to_be_regularized')">
            <v-simple-table dense>
                <template v-slot:default>
                    <thead>
                    <tr>
                        <th class="text-left"> {{ $t('common.month') }}</th>
                        <th class="text-left"> {{ $t('common.name') }}</th>
                        <th class="text-left"></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr
                        v-for="item in correction.correctionPaySlips"
                        :key="item.id"
                    >
                        <td class="text-left">{{ item.originalPaySlipAnnexMonth }}</td>
                        <td class="text-left">{{ item.originalPaySlipAnnexName }}</td>
                        <td class="text-left">
                            <w-btn-icon
                                icon="mdi-account-credit-card"
                                color="teal"
                                @press="$router.push({name: 'pay_slips.view', params: {id: item.originalPaySlipId}})"
                            />
                        </td>
                    </tr>
                    </tbody>
                </template>
            </v-simple-table>
        </w-fieldset>
        <br/>
        <w-fieldset :title="$t('pay_slip.value_to_be_corrected')">
            <v-simple-table dense>
                <template v-slot:default>
                    <thead>
                    <tr>
                        <th class="text-left"> {{ $t('common.code') }}</th>
                        <th class="text-left"> {{ $t('common.label') }}</th>
                        <th class="text-left"> {{ $t('common.value') }}</th>
                        <th class="text-left"> {{ $t('common.percent') }}</th>
                        <th class="text-left"></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr
                        v-for="item in correction.correctionValues"
                        :key="item.paySectionId"
                    >
                        <td class="text-left">
                            <w-tooltip
                                :label="item.paySectionCode"
                                :tooltip="item.paySectionFormule"
                            />
                        </td>
                        <td class="text-left">{{ item.paySectionLabel }}</td>
                        <td class="text-left"> {{ item.value }}</td>
                        <td class="text-left">
                            <v-simple-checkbox v-model="item.byPercent"/>
                        </td>
                        <td class="text-left">
                        </td>
                    </tr>
                    </tbody>
                </template>
            </v-simple-table>
        </w-fieldset>
        <br/>
        <w-fieldset :title="$t('pay_slip.bulletin')">
            <v-simple-table
                dense
                fixed-header
                style="border-collapse: collapse; border: 1px solid black;"
            >
                <template v-slot:default>
                    <thead>
                    <tr>
                        <th class="text-left">{{ $t('common.code') }}</th>
                        <th class="text-left">{{ $t('pay_slip.pay_section') }}</th>
                        <th class="text-left">{{ $t('pay_slip.earnings') }}</th>
                        <th class="text-left">{{ $t('pay_slip.restraint') }}</th>
                        <th class="text-left">{{ $t('pay_slip.base') }}</th>
                        <th class="text-left">{{ $t('pay_slip.rate') }}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(v, i) in correction.correctionPaySections.filter(e => e.paySectionBulteinePrintable !== '5' && e.value !== 0).sort((a, b) => a.paySectionOrdre - b.paySectionOrdre)"
                        :key="i">
                        <td :style="v.paySectionBulteinePrintable === '4' ? 'color: red;' : ''">
                            <w-tooltip
                                :label="v.paySectionCode"
                                :tooltip="v.paySectionFormule"
                            />
                        </td>
                        <td :style="v.paySectionBulteinePrintable === '4' ? 'color: red;' : ''">
                            {{ v.paySectionLabel }}
                        </td>
                        <td style="color: green">
                            <div v-if="v.paySectionBulteinePrintable === '3'">
                                {{ priceFormat(v.difference) }}
                            </div>
                        </td>
                        <td style="color: red">
                            <div v-if="v.paySectionBulteinePrintable === '4'">
                                {{ priceFormat(v.difference) }}
                            </div>
                        </td>
                        <td style="color: blue">
                            <div v-if="v.baseDifference !== null && v.baseDifference !== 0">
                                {{ priceFormat(v.baseDifference) }}
                            </div>
                        </td>
                        <td style="color: blue">
                            <div v-if="v.tauxDifference !== null && v.tauxDifference !== 0">
                                {{ priceFormat(v.tauxDifference) }}
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </template>
            </v-simple-table>
        </w-fieldset>
    </v-container>
</template>

<style scoped>

</style>